import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StudyLandingComponent } from './__PAGES/__LANDINGS/study-landing/study-landing.component';
import { WorkLandingComponent } from './__PAGES/__LANDINGS/work-landing/work-landing.component';
import { AccommodationLandingComponent } from './__PAGES/__LANDINGS/accommodation-landing/accommodation-landing.component';
import { ExtranjeriaLandingComponent } from './__PAGES/__LANDINGS/extranjeria-landing/extranjeria-landing.component';
import { InsuranceLandingComponent } from './__PAGES/__LANDINGS/insurance-landing/insurance-landing.component';
import { VisadoLandingComponent } from './__PAGES/__LANDINGS/visado-landing/visado-landing.component';


const routes: Routes = [

  // ESTUDIAR
  /* { path: '', component: StudyLandingComponent },
  { path: 'estudiar', component: StudyLandingComponent },
  { path: 'estudiarespaña', component: StudyLandingComponent },
  { path: 'estudiareuropa', component: StudyLandingComponent },
  { path: 'estudiarenespaña', component: StudyLandingComponent },
  { path: 'estudiareneuropa', component: StudyLandingComponent },
  { path: 'estudios', component: StudyLandingComponent },
  { path: 'master', component: StudyLandingComponent },
  { path: 'mastermadrid', component: StudyLandingComponent },
  { path: 'masterespaña', component: StudyLandingComponent },
  { path: 'mastereuropa', component: StudyLandingComponent },
  { path: '**', redirectTo: '' },  */

  // VISADO
  { path: '', component: VisadoLandingComponent },
  { path: 'visado', component: VisadoLandingComponent },
  { path: 'visado-estudios', component: VisadoLandingComponent },
  { path: 'visado-estudiar', component: VisadoLandingComponent },
  { path: 'visado-espana', component: VisadoLandingComponent },
  { path: 'visa-estudiante', component: VisadoLandingComponent },
  { path: 'visa', component: VisadoLandingComponent },
  { path: 'visa-estudiar', component: VisadoLandingComponent },
  { path: 'visa-barcelona', component: VisadoLandingComponent },
  { path: 'visa-madrid', component: VisadoLandingComponent },
  { path: '**', redirectTo: '' }

  // SEGURO MEDICO
/*   { path: '', component: InsuranceLandingComponent },
  { path: 'seguro', component: InsuranceLandingComponent },
  { path: 'contratar-seguro', component: InsuranceLandingComponent },
  { path: 'contratar-seguro-medico', component: InsuranceLandingComponent },
  { path: 'seguros', component: InsuranceLandingComponent },
  { path: '**', redirectTo: '' },  */

  // ACCOMMODATION
/*   { path: '', component: AccommodationLandingComponent }, */
/*   { path: 'vivienda', component: AccommodationLandingComponent },
  { path: 'alquiler', component: AccommodationLandingComponent },
  { path: 'apartamento', component: AccommodationLandingComponent },
  { path: 'aparta', component: AccommodationLandingComponent },
  { path: 'apartamentos', component: AccommodationLandingComponent },
  { path: 'piso', component: AccommodationLandingComponent },
  { path: 'pisos', component: AccommodationLandingComponent },
  { path: 'pisosmadrid', component: AccommodationLandingComponent },
  { path: 'pisosbarcelona', component: AccommodationLandingComponent },
  { path: 'apartamentomadrid', component: AccommodationLandingComponent },
  { path: 'apartamentobarcelona', component: AccommodationLandingComponent },
   { path: '**', redirectTo: '' },  */

  // WORK
  // https://codepen.io/sanketbodke/pen/bGRVKYr
/*   { path: '', component: WorkLandingComponent },
  { path: 'trabajar', component: WorkLandingComponent },
  { path: 'trabajo', component: WorkLandingComponent },
  { path: 'comotrabajar', component: WorkLandingComponent },
  { path: 'trabajarespaña', component: WorkLandingComponent },
  { path: 'trabajarmadrid', component: WorkLandingComponent },
  { path: 'trabajarbarcelona', component: WorkLandingComponent },
  { path: 'trabajoespaña', component: WorkLandingComponent },
  { path: 'noomadadigital', component: WorkLandingComponent }, */

  // EXTRANJERIA
  // https://codepen.io/sanketbodke/pen/bGRVKYr
/*   { path: 'extranjeria', component: ExtranjeriaLandingComponent },
  { path: 'tramites', component: ExtranjeriaLandingComponent },
  { path: 'noomadadigital', component: ExtranjeriaLandingComponent }, */

/*   { path: 'demo', component: FullScreenBannerAComponent } */
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
